import { Component, OnInit, Input } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular';

@Component({
    selector: 'app-action-sheet-popover',
    templateUrl: './action-sheet-popover.component.html',
    styleUrls: ['./action-sheet-popover.component.scss'],
})
export class ActionSheetPopoverComponent implements OnInit {

    @Input() data: any;

    constructor(private popOverController: PopoverController, private modalController: ModalController) {

    }

    ngOnInit() {
    }

    closeModal(item) {
        //this.modalController.getTop().then((x) => {
        //    if (x) {
        //        try {
        //            x.dismiss(item).then((y) => {
        //                this.closeModal(item);
        //            });
        //        }
        //        catch (e) {

        //        }
        //    }
        //});
        this.modalController.dismiss(item);
    }

    newService() {
        this.closeModal(null);
    }

    itemClick(item, action) {
        if (!item.Button && action === null)
            return;

        this.closeModal({ ...item, SubAction: action });
    }

    async presentModal(item: any) {

        if (!item.SubServices || item.SubServices.length === 0) {
            this.closeModal(item);
            return;
        }

        const modal = await this.modalController.create({
            component: ActionSheetPopoverComponent,
            cssClass: 'auto-height-dock-bottom',
            componentProps: { data: item.SubServices }
        });
        return await modal.present();
    }
}
